import React from "react";
import "./LoadingScreen.css"; // Ensure the correct CSS path

const LoadingScreen = ({ message = "Loading..." }) => {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p className="loading-text">{message}</p>
    </div>
  );
};

export default LoadingScreen; // ✅ Make sure it's a default export

